
export const GET_CAR_REQUEST ="GET_CAR_REQUEST" ;
export const GET_CAR_SUCCESS ="GET_CAR_SUCCESS" ;
export const GET_CAR_ERROR   ="GET_CAR_ERROR"   ;